import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core';
import { SupplementProtocolBuilderPage } from '../pages/client/supplement-protocol-builder/supplement-protocol-builder.page';

interface OpenSupplementProtocolBuilderModalOptions {
  id?: string;
  type?: 'user' | 'library';
  userId?: string;
  duplicate?: string;
  mode?: string;
  backdropDismiss?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SupplementProtocolBuilderModalService {
  constructor(private modalCtrl: ModalController) {}

  async open(options: OpenSupplementProtocolBuilderModalOptions = {}): Promise<OverlayEventDetail<any>> {
    const modal = await this.modalCtrl.create({
      component: SupplementProtocolBuilderPage,
      cssClass: 'meal-plan-side-modal',
      backdropDismiss: options.backdropDismiss ?? false,
      componentProps: {
        modalContext: {
          supplementProtocolUser: options.userId,
          id: options.id || 'add',
          type: options.type || 'user',
          ...(options.mode ? { mode: options.mode } : {}),
          ...(options.duplicate ? { duplicate: options.duplicate } : {}),
        },
      },
    });

    await modal.present();
    return modal.onDidDismiss();
  }
}
